import config from '../../assets/js/conf/config'
import request from '../../assets/js/utils/request'

/** 售后筛选项（店铺、类型、状态 Tab 等） */
export function getAftersaleFilters(data) {
	return request.get(config.baseApiB + '/api/v1/wxshop/aftersale/filters', data || {})
}

/** 售后列表 */
export function getAftersaleList(data) {
	return request.get(config.baseApiB + '/api/v1/wxshop/aftersale/list', data || {})
}

/** 售后详情 */
export function getAftersaleDetail(data) {
	return request.get(config.baseApiB + '/api/v1/wxshop/aftersale/detail', data || {})
}

/** 同意售后（仅退款 / 退货退款） */
export function postAftersaleAccept(data) {
	return request.post(config.baseApiB + '/api/v1/wxshop/aftersale/accept', data || {})
}

/** 拒绝售后 */
export function postAftersaleReject(data) {
	return request.post(config.baseApiB + '/api/v1/wxshop/aftersale/reject', data || {})
}

/** 批量同意（退款 / 退货） */
export function postAftersaleBatchAccept(data) {
	return request.post(config.baseApiB + '/api/v1/wxshop/aftersale/batch-accept', data || {})
}
